<div
	class="tw:h-(--topbar-height) tw:bg-surface-primary tw:flex tw:items-center tw:justify-between tw:py-4 tw:px-2 tw:lg:px-6"
>
	<div class="tw:md:hidden">
		<img width="144" height="48" src="/logos/zeraki-finance.svg" class="logo" alt="" />
	</div>
	<app-topbar-school-switching [internalView]="internalView()" />
	<div class="tw:flex tw:items-center tw:gap-3 tw:lg:gap-6">
		@if (!internalView()) {
			<app-topbar-search />
		}
		<app-topbar-language-selection />
		<app-topbar-user-profile />
	</div>
</div>
